import { render, staticRenderFns } from "./CancellationReasonSection.vue?vue&type=template&id=4b323aeb&scoped=true"
import script from "./CancellationReasonSection.vue?vue&type=script&lang=js"
export * from "./CancellationReasonSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b323aeb",
  null
  
)

export default component.exports